import { Card, CardContent, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useTranslation } from "react-i18next";
import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { HomeTeam } from "src/sections/home/home-team";

import Markdown from "react-markdown";

import { PluggableList } from "react-markdown/lib";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "src/pages/dashboard/helpers/markdownlhelpers";

const Page = () => {
  const { t } = useTranslation();
  usePageView();
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  // About Us page structured data
  const aboutPageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: t("Aboutus") || "About Us",
    description:
      "Learn about Opensource.clinic, our mission to provide affordable diabetes management solutions, and our team dedicated to supporting the open-source diabetes community.",
    url: "https://www.opensource.clinic/aboutus",
    mainEntity: {
      "@type": "Organization",
      name: "Opensource.clinic",
      description:
        "A team dedicated to providing Nightscout hosting and personalized coaching for diabetes management using open-source technology.",
    },
  };

  return (
    <>
      <Seo
        title={t("Aboutus") || "About Us"}
        description="Learn about Opensource.clinic, our mission to provide affordable diabetes management solutions, and our team dedicated to supporting the open-source diabetes community."
        structuredData={aboutPageSchema}
      />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "neutral.800" : "neutral.50",
            height: mdUp ? undefined : "auto",
            flexGrow: 1,
            pb: 10,
            pt: 5,
          }}
        >
          <Container maxWidth="md">
            <HomeTeam extended />
            <Box sx={{ my: 4 }}>
              <Card
                sx={{
                  background: (theme) =>
                    theme.palette.mode === "dark"
                      ? "linear-gradient(135deg, rgba(25, 118, 210, 0.1) 0%, rgba(25, 118, 210, 0.05) 100%)"
                      : "linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(25, 118, 210, 0.02) 100%)",
                  border: (theme) =>
                    `1px solid ${
                      theme.palette.mode === "dark"
                        ? "rgba(25, 118, 210, 0.3)"
                        : "rgba(25, 118, 210, 0.2)"
                    }`,
                }}
              >
                {/* <CardContent>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{ mb: 2 }}
                  >
                    <VerifiedIcon
                      sx={{
                        color: "primary.main",
                        fontSize: "1.5rem",
                      }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Professional Credentials
                    </Typography>
                  </Stack>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    Our team includes registered healthcare professionals
                    committed to providing quality diabetes care and support.
                  </Typography>
                  <Link
                    href="https://zoeken.bigregister.nl/zorgverlener/ea35cb3f-53a3-4247-b9f1-7e47e4692827"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 1,
                      color: "primary.main",
                      textDecoration: "none",
                      fontWeight: 500,
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    <Typography variant="body2" component="span">
                      View Medical Registration
                    </Typography>
                    <Box
                      component="span"
                      sx={{
                        fontSize: "0.875rem",
                        opacity: 0.7,
                      }}
                    >
                      ↗
                    </Box>
                  </Link>
                </CardContent> */}
              </Card>
            </Box>
            {/* <Box
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                mb: 2,
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  mt: 2,
                  mb: 2,
                  color: theme.palette.primary.main,
                }}
              >
                {t("About Us")}
              </Typography>
              <Typography color="text.secondary" sx={{ mb: 2 }} variant="body1">
                {t("TheTeamSubtitle")}
              </Typography>
            </Box>

            <Grid container spacing={4}>
              <Grid xs={12} md={6}>
                <PostCard
                  cover="/assets/aboutus/us3.png"
                  postId={"TEST"}
                  title={t("The Founders")}
                  subTitle={t("TheFoundersSubtitle")}
                  shortDescription={t("TheFoundersText")}
                  sx={{ height: "100%" }}
                />
              </Grid>
              <Grid xs={12} md={6}>
                <PostCard
                  cover="/assets/aboutus/worldwide.png"
                  postId={"TEST"}
                  title={t("TheTeam")}
                  subTitle={t("TheTeamSubtitle")}
                  shortDescription={t("TheTeamDescription")}
                  sx={{ height: "100%" }}
                />
              </Grid>
            </Grid> */}
            <Box sx={{ my: 4 }}>
              <Card>
                <CardContent>
                  <Typography variant="h5">{t("JoinTheTeam")}</Typography>
                  {/* <Typography variant="body1">{t("JoinTheTeam")}</Typography> */}
                  <Markdown
                    children={t("JobsDescription")}
                    components={markdownComponents}
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw] as PluggableList}
                  />
                </CardContent>
              </Card>
            </Box>
          </Container>
        </Box>
        <Divider />
        {/* <PricingFaqs /> */}
      </Box>
    </>
  );
};

export default Page;
